<template>
    <v-layout>
        <div class="col-12">
            <v-toolbar flat>
                <v-toolbar-title>{{ $t('transfer_coins_to_redeem_partner') }}</v-toolbar-title>
                <template v-slot:extension>
                    <v-tabs
                            v-model="tab"
                            align-with-title
                    >
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab> {{ $t('transfer_coins') }}</v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card>
                        <redeems v-if="tab==0"/>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </v-layout>
</template>
<script>
    import Redeems from "@/views/CompanyRedeems";
    // import RedeemsQueue from "@/views/RedeemsQueue";
    export default {
        components: {
            redeems: Redeems,
            // redeemsqueue: RedeemsQueue,
        },
        name: "CompanyRedeemsWrapper",
        data: () => ({
            loading: false,
            tab: null,
        })
    }
</script>
